import LandDetail from './LandDetail';

export default LandDetail;
